import { render, staticRenderFns } from "./OgConsultantSelect.vue?vue&type=template&id=defff6d0&"
import script from "./OgConsultantSelect.vue?vue&type=script&lang=js&"
export * from "./OgConsultantSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports